import React from 'react'
import PropTypes from 'prop-types'
import debounce from 'lodash/debounce'

import Input from '../Input/Input'

export default class InputDebounce extends React.PureComponent {
    static propTypes = {
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        debounceTime: PropTypes.number,
        maxLength: PropTypes.number,

        onChange: PropTypes.func.isRequired,
    }

    static defaultProps = {
        debounceTime: 300,
        maxLength: 50,
    }

    constructor(props) {
        super(props)

        this.state = {
            value: props.value,
        }

        this.onChangeDebounce = debounce(props.onChange, props.debounceTime)
    }

    componentWillUnmount() {
        this.onChangeDebounce.cancel()
    }

    componentWillReceiveProps({ value }) {
        if (this.state.value !== value) {
            this.setState({ value })
        }
    }

    handleSearchChange = (value) => {
        value = value.slice(0, this.props.maxLength)
        this.setState({ value })
        this.onChangeDebounce(value)
    }

    render() {
        return (
            <Input
                {...this.props}
                value={this.state.value}
                onChange={this.handleSearchChange}
            />
        )
    }
}



// WEBPACK FOOTER //
// ../node_modules/react-mt-bootstrap/lib/components/InputDebounce/InputDebounce.jsx